import URL2 from '../config.js'
import { getCampusSessions } from '../utils/campusPaymentCharges.js'

const checkStatus = async (extra = {}) => {
    try {
        const logID = localStorage.getItem('LogID');
        
        // Check if LogID exists and is not 'NA'
        if (logID && logID !== 'NA' && logID !== 'null') {
            try {
                const campusSessions = extra.campusSessions || getCampusSessions();
                const response = await URL2.post('/checkStatus', {
                    SessionID: logID,
                    campusSessions: Array.isArray(campusSessions) ? campusSessions : [],
                    ...extra,
                });

                return response.data;
            } catch (error) {
                console.error("Error in checkStatus API call:", error);
                return null;
            }
        } else {
            console.log("LogID not available or is 'NA', skipping status check");
            return null;
        }
    } catch (error) {
        console.error("Error in checkStatus function:", error);
        return null;
    }
};
export default checkStatus;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * The family's status, asked up to three times. checkStatus answers null for any failure — a request
 * that failed, a slow AIC Connect, an expired token — and the pages after a payment used to stop dead
 * on that null, leaving a parent who had just paid on a spinner until they refreshed. Null here
 * means it still could not be read; the caller must then say so or carry on, never wait.
 */
export const readStatusWithRetries = async (read = checkStatus, { attempts = 3, delayMs = 1200 } = {}) => {
    for (let attempt = 1; attempt <= attempts; attempt += 1) {
        const data = await read();
        if (data && data.RenrolStatus !== undefined) return data;
        if (attempt < attempts) await wait(delayMs * attempt);
    }
    return null;
};
